import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import CapitalBalanceSummaryTable from './CapitalBalanceSummaryTable';

export const CapitalBalanceSummaryList = ({ config }) => {
  const dispatch = useDispatch();
  const summary = useSelector(config.selectors.selectSummaryList);
  const count = useSelector(config.selectors.selectSummaryCount);
  const queryOptions = useSelector(config.selectors.selectQueryOptions);
  const loading = useSelector(
    isLoadingSelector([config.loadSummaryActionType.action])
  );
  const success = useSelector(
    successSelector([config.loadSummaryActionType.action])
  );
  const page = queryOptions?.page || 0;

  useEffect(() => {
    dispatch(
      config.actions.loadSummary({
        page: 0,
        limit: +process.env.REACT_APP_TABLE_SIZE
      })
    );
  }, [dispatch, config.actions]);

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(
        config.actions.loadSummary({
          page: value,
          limit: +process.env.REACT_APP_TABLE_SIZE
        })
      );
    },
    [dispatch, config.actions]
  );

  if (success && !loading && (summary?.length === 0 || count === 0)) {
    return (
      <Card>
        <NotFoundRecords
          title={config.notFoundTitle}
          description={config.notFoundDescription}
        />
      </Card>
    );
  }

  return (
    <CapitalBalanceSummaryTable
      summary={summary}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
      loadActionType={config.loadSummaryActionType}
    />
  );
};

CapitalBalanceSummaryList.propTypes = {
  config: PropTypes.object.isRequired
};

export default CapitalBalanceSummaryList;

